import {Button, Card, CardContent, Divider, IconButton, Stack, Typography} from "@mui/material";
import Iconify from "../../components/Iconify";
import B2BDialog from "./InvoiceForm/B2BDialog";
import {useState} from "react";
import {useFormContext, useWatch} from "react-hook-form";
import {IconButtonAnimate} from "../../components/animate";

export default function B2B() {
    const {
        setValue, control, formState: {errors},
    } = useFormContext();

    const [openTo, setOpenTo] = useState(false);

    const selectedCustomer = useWatch({
        control, name: "customer"
    })

    const handleOpenTo = () => {
        setOpenTo(true);
    };

    const handleCloseTo = () => {
        setOpenTo(false);
    };

    const handleRemoveCustomer = () => {
        setValue('customer', "")
    }

    return (<Stack  direction="column" spacing={1} width={selectedCustomer !== "" ? 1 : null}>
        <Stack direction="row"  spacing={1} justifyContent="space-between" width={1}>
            {selectedCustomer !== "" ? (<B2BInfo customer={selectedCustomer}/>) : (
                <Typography typography="caption" sx={{color: 'error.main'}}>
                    {errors.invoiceTo?.message}
                </Typography>)}
            <Stack direction="row" alignItems="flex-start">
                <Stack direction="row" justifyContent="center">
                    {selectedCustomer !== "" ? (
                        <IconButton
                            color="primary"
                            size="small"
                            onClick={handleOpenTo}
                        >
                            <Iconify icon="eva:edit-2-fill" />
                        </IconButton>
                    ) : (
                        <Button
                            size="small"
                            sx={{ width: 170, height: 80 }}
                            color="primary"
                            variant="outlined"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                            onClick={handleOpenTo}
                        >
                            Izaberi B2B
                        </Button>
                    )}

                    {selectedCustomer && <IconButtonAnimate
                        color={'error'}
                        onClick={handleRemoveCustomer}
                        variant="outlined"
                        sx={{
                            width: 45, height: 45,
                        }}
                    >
                        <Iconify icon="solar:trash-bin-minimalistic-bold-duotone"/>
                    </IconButtonAnimate>}
                </Stack>

            </Stack>
        </Stack>
        {openTo && <B2BDialog
            open={openTo}
            onClose={handleCloseTo}
        />}
    </Stack>)
}

// ----------------------------------------------------------------------


function B2BInfo({ customer }) {
    if (!customer) return null;

    return (
        <Card
            variant="outlined"
            sx={{
                width: '100%',
                borderRadius: 2,
                p: 1,
                boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
            }}
        >
            <CardContent sx={{ py: 1.5, px: 2 }}>
                <Typography
                    variant="subtitle2"
                    sx={{ color: 'text.secondary', mb: 1 }}
                >
                    🧾 Podaci kupca
                </Typography>

                <Divider sx={{ mb: 1 }} />

                <Stack spacing={0.5}>
                    <Typography variant="body2">
                        <strong>Naziv:</strong> {customer.name || '-'}
                    </Typography>
                    <Typography variant="body2">
                        <strong>PIB:</strong> {customer.tin || '-'}
                    </Typography>
                    <Typography variant="body2">
                        <strong>JBKJS:</strong> {customer.jbkjs || '-'}
                    </Typography>
                </Stack>
            </CardContent>
        </Card>
    );
}
